import React, { FC } from 'react'

const Logo: FC = ({ className = '', ...props }) => (
  <div>
    <span>Storedog</span>
  </div>
)

export default Logo
